import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { apiError } from "../lib/api";
import { uploadImage } from "../lib/upload";

export const UploadBtn = ({ onDone, testId }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  return (
    <>
      <button type="button" data-testid={testId} onClick={() => ref.current.click()} disabled={busy} className="nb-btn nb-btn-sm flex-shrink-0">
        <Upload className="w-4 h-4" /> {busy ? "Uploading..." : "Upload"}
      </button>
      <input type="file" accept="image/jpeg,image/png,image/webp,image/gif" hidden ref={ref} onChange={async (e) => {
        const f = e.target.files[0];
        e.target.value = "";
        if (!f) return;
        setBusy(true);
        try { onDone(await uploadImage(f)); toast.success("Image uploaded"); }
        catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
      }} />
    </>
  );
};
